import * as http from '~/utils/apis';
import { clearToken } from '~/services/auth/auth.service';
import { UNAUTHORIZED } from '~/config/constants';

const checkDuplicateNameApi = async (name, cardType) => {
    try {
        const { status } = await http.get(`cms-api/duplicate-name`, {
            name: name,
            cardType: cardType,
        });
        return !status;
    } catch (error) {
        if (error.message === UNAUTHORIZED) {
            clearToken();
            window.location.href = window.location.origin + '/login';
        }
    }
};

export default checkDuplicateNameApi;
